<template>
  <div :style="style.style" class="cotent" v-if="isShow">
    <img
      @click="open(item.clickFun)"
      :style="item.style"
      :key="index"
      :src="item.src"
      v-for="(item, index) in style.list"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

const style = ref(window.globalConfig.rightBarStyle);
const hiddeList = ["/newsDetail"];
const route = useRoute();
const isShow = computed(() => {
  return !hiddeList.includes(route.fullPath);
});
const open = (clickFun) => {
  if (!clickFun) return;
  clickFun();
};
</script>

<style lang="scss">
.cotent {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
</style>
